import isBrowser from "../isBrowser"

const getUserLocale = (locale?: string) => locale || (isBrowser() ? navigator.language : "de-DE")

export default getUserLocale
